import { Flex } from "@chakra-ui/react"
import { CheckCircle } from "../../icons"

export const BusinessId = ({ businessId }: { businessId: string }) => {
    return (
        <Flex my={1} sx={{ gap: 2, flexWrap: 'wrap' }}>
            <CheckCircle color="secondary.500" />
            {`IČO: ${businessId}`}
        </Flex>
    )
}